// class-component-hooks.js
import Component from 'vue-class-component';
// Register the router hooks with their names
Component.registerHooks([
	'beforeRouteEnter',
	'beforeRouteLeave',
	'beforeRouteUpdate',
	'validations',
]);